module.exports = __webpack_public_path__ + "assets/chart_icons_dark.png";